// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"54824ee8","453":"6e862f1a","455":"7d71990c","977":"43bcb9b9"}[chunkId] + ".chunk.js";
};